import { Transaction } from '@features/transactions/types/transaction'

import { Paging } from '../../../../../types/metable'
import { useTransactionsListFilters } from '../../../contexts/transactionsListFiltersContext'
import { useFetchTransactions } from './useFetchTransactions'

interface UseTransactionsResponse {
  isLoading: boolean
  pagination?: Paging
  transactions: Transaction[]
}

export const useTransactions = (): UseTransactionsResponse => {
  const { appliedFilters } = useTransactionsListFilters()
  const { isLoading, pagination, transactions } = useFetchTransactions(appliedFilters)

  return {
    isLoading,
    pagination,
    transactions,
  }
}
